import { PointerDragging } from "@fullcalendar/interaction";
import moment from "moment";
import React, { useState, Fragment } from "react";
import { Modal, Button } from "react-bootstrap";

const PassengerModal = ({ show, handleClose, response }) => {
  // console.log(response.data);

  const printPassengerDetails = (printModal) => {
    var divContents = document.getElementById("printModal").innerHTML;
    var a = window.open("", "", "height=900, width=900");
    a.document.write(
      `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.1/dist/css/bootstrap.min.css" integrity="sha384-zCbKRCUGaJDkqS1kPbPd7TveP5iyJE0EjAuZQTgFLD2ylzuqKfdKlfG/eSrtxUkn" crossorigin="anonymous"> `
    );
    a.document.write(divContents);
    a.print();
  };
  return (
    <Fragment>
      <Modal show={show} size="xl" scrollable={true}>
        <Modal.Header
          className="text-primary"
          style={{ fontSize: "20px", fontWeight: "bold" }}
        >
          Booking Details
        </Modal.Header>

        <Modal.Body>
          <>
            <div className="modal-body" id="printModal">
              <span
                style={{
                  fontSize: "15px",
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                Passenger Details :
              </span>
              <div className="mainContainer-modal">
                <div className="col-12">
                  <table className="table table-striped border text-center table-inverse">
                    <thead className="thead-inverse  bg-primary text-white">
                      <tr>
                        <th scope="col">Title</th>
                        <th scope="col">First Name</th>
                        <th scope="col">Last Name</th>

                        <th>Date of Birth</th>
                        <th scope="col">Passenger Type</th>
                        <th scope="col">PNR</th>
                        {response.isDomestic == false && (
                          <>
                            <th scope="col">Passport No.</th>
                            <th scope="col">Passport Issue Date</th>
                            <th scope="col">Passport Expiry Date</th>
                            <th scope="col">Passport Nationality</th>
                          </>
                        )}
                      </tr>
                    </thead>

                    <tbody className="text-center">
                      {
                        // Object.keys(response?.passengerList).length !== 0 &&
                        response?.passengerList?.map((passenger) => (
                          <tr>
                            <td scope="row">{passenger?.title}</td>
                            <td>{passenger?.firstName}</td>
                            <td>{passenger?.lastName}</td>

                            <td>
                              {passenger?.birthDate?.length > 0
                                ? passenger.birthDate
                                : "Not available"}
                            </td>

                            <td>{passenger?.passengerType}</td>
                            <td>
                              {passenger?.pnr != null
                                ? passenger?.pnr
                                : "Not Available"}
                            </td>
                            {response.isDomestic == false && (
                              <>
                                <td>
                                  {passenger?.passport != null
                                    ? passenger?.passport
                                    : "Not Available"}
                                </td>
                                <td>
                                  {passenger?.passportIssueDate != null
                                    ? moment(
                                        passenger?.passportIssueDate
                                      ).format("DD-MM-YYYY")
                                    : "Not Available"}
                                </td>
                                <td>
                                  {passenger?.passportExpiryDate != null
                                    ? moment(
                                        passenger?.passportExpiryDate
                                      ).format("DD-MM-YYYY")
                                    : "Not Available"}
                                </td>
                                <td>
                                  {passenger?.passportNationality != null
                                    ? passenger?.passportNationality
                                    : "Not Available"}
                                </td>
                              </>
                            )}
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              {response.gstNumber &&
                response.gstRegisteredName &&
                response.gstRegisteredAddress &&
                response.gstEmail &&
                response.gstRegisteredMobileNo && (
                  <span
                    style={{
                      fontSize: "15px",
                      marginBottom: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    GST Details :
                  </span>
                )}
              <div className="mainContainer-modal">
                <div className="col-12">
                  <table className="table table-striped border text-center table-inverse">
                    <thead className="thead-inverse  bg-primary text-white">
                      <tr>
                        {response.gstNumber && <th scope="col">Number</th>}
                        {response.gstRegisteredName && (
                          <th scope="col">Name</th>
                        )}
                        {response.gstRegisteredAddress && (
                          <th scope="col">Address</th>
                        )}
                        {response.gstEmail && <th scope="col">Mail Id</th>}
                        {response.gstRegisteredMobileNo && (
                          <th scope="col">Mobile No.</th>
                        )}
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      <tr>
                        {response.gstNumber && (
                          <td scope="row">{response.gstNumber}</td>
                        )}
                        {response.gstRegisteredName && (
                          <td scope="row">{response.gstRegisteredName}</td>
                        )}
                        {response.gstRegisteredAddress && (
                          <td scope="row">{response.gstRegisteredAddress}</td>
                        )}
                        {response.gstEmail && (
                          <td scope="row">{response.gstEmail}</td>
                        )}
                        {response.gstRegisteredMobileNo && (
                          <td scope="row">{response.gstRegisteredMobileNo}</td>
                        )}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default PassengerModal;
